import { createApp } from 'vue'
import Bugsnag from './plugins/bugsnag'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// Roboto ships with the app instead of coming from Google Fonts: a page view
// must not send the visitor's IP address to Google (GDPR).
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import hasRole from './plugins/hasRole'
import router from './router'
import store from './store'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'

import 'dayjs/locale/et'
import registerComponents from './plugins/components'
import { shortAddress } from './plugins/utils'

// After ./plugins/vuetify on purpose: that is where vuetify/styles is imported,
// and CSS lands in the bundle in the order it is imported. See the file itself
// for what it restores.
import './styles/v2-parity.css'

dayjs.locale('et')
dayjs.extend(customParseFormat)

const app = createApp(App)

Bugsnag.getPlugin('vue').installVueErrorHandler(app)

app.use(vuetify)
app.use(router)
app.use(store)
app.use(hasRole)
// Addresses on screen, without the ", Estonia" the server appends.
app.config.globalProperties.$address = shortAddress
registerComponents(app)

app.mount('#app')
